import { Injectable } from '@angular/core';
import { UserStatus } from './user.types';

@Injectable({
    providedIn: 'root',
})
export class UserHelperService {
    constructor() {}

    public canEditUser(status: string): boolean {
        // There is no status for the time being, so to enable "Edit", null/blank status must be allowed.
        return (
            !status ||
            status?.toLowerCase() === UserStatus.Invited ||
            status?.toLowerCase() === UserStatus.Active ||
            status?.toLowerCase() === UserStatus.Existing
        );
        // return !!status && (status.toLowerCase() === UserStatus.Invited || status.toLowerCase() === UserStatus.Active);
    }

    public canViewUserActivity(status: string): boolean {
        return true;
    }

    public canResendInvitation(status: string): boolean {
        return !!status && status.toLowerCase() === UserStatus.Invited;
    }

    public canSendPwReset(status: string): boolean {
        return (
            !!status &&
            (status?.toLowerCase() === UserStatus.Invited ||
                status?.toLowerCase() === UserStatus.Active ||
                status?.toLowerCase() === UserStatus.Existing)
        );
    }

    public canBlock(status: string): boolean {
        return (
            !!status &&
            (status?.toLowerCase() === UserStatus.Invited ||
                status?.toLowerCase() === UserStatus.Active ||
                status?.toLowerCase() === UserStatus.Existing)
        );
    }

    public canUnblock(status: string): boolean {
        return !!status && status.toLowerCase() === UserStatus.Blocked;
    }

    public canDeactivate(status: string): boolean {
        return (
            !!status &&
            (status?.toLowerCase() === UserStatus.Invited ||
                status?.toLowerCase() === UserStatus.Active ||
                status?.toLowerCase() === UserStatus.Existing ||
                status?.toLowerCase() === UserStatus.Blocked)
        );
    }
}
